var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{name: 'RubricVersions', params: {rid: _vm.params.data.id }}}},[_vm._v(" "+_vm._s(_vm.params.data.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }